import Firebase from './Firebase'
import FirebaseProvider from './FirebaseProvider'

export {
  Firebase as default,
  FirebaseProvider,
}
